import { useEffect, useState } from "react";

import { useFormikWrapper } from "../../../components/formik_wrapper";
import * as Yup from "yup";

import { Modal, Tooltip } from "flowbite-react";
import { Popup } from "../../../components/pop-up";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../actions/index";

import { TextBox } from "../../../components/inputs";
import { RESETCOWORKERPWD_RESPONSE } from "../../../constants/action_types";
import { FlatButton, IconButton } from "../../../components/buttons";
import { ACL } from "../../../components/acl";
import { ADMIN, SUPERADMIN, FINANCEADMIN } from "../../../constants/roles";

export function ResetPasswordAction({ data, type = "icon" }) {
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState();
  const [qrCode, setQRcode] = useState();
  const [modalState, setModalState] = useState();

  const coworkerUpdated = useSelector(
    (state) => state?.coworker?.update_response
  );

  useEffect(() => {
    if (
      coworkerUpdated?.type === RESETCOWORKERPWD_RESPONSE &&
      coworkerUpdated.payload.coworker_uid === data?.coworker_uid
    ) {
      setQRcode(coworkerUpdated?.payload?.data);
    }
  }, [coworkerUpdated]);

  useEffect(() => {
    if (qrCode) setModalState("pop-up");
  }, [qrCode]);

  const passwordForm = useFormikWrapper({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Please enter the password")
        .min(8, "Password must be atleast 8 characters"),
      confirm_password: Yup.string()
        .required("Please confirm the password")
        .oneOf([Yup.ref("password")], "Your passwords do not match."),
    }),
    onSubmit: () => {
      dispatch(
        actions.RESETCOWORKERPWD_REQ({
          ...data,
          ...passwordForm.values,
        })
      );
      setOpenModal();
      resetForm();
    },
  });

  const resetForm = () => {
    passwordForm.setTouched({
      password: false,
      confirm_password: false,
    });
    passwordForm.setValues({
      password: "",
      confirm_password: "",
    });
  };

  const closeModal = () => {
    dispatch(actions.RESET_STATE("coworker.update_response"));
    setModalState(undefined);
    setQRcode(undefined);
  };

  return (
    <ACL showFor={[SUPERADMIN, ADMIN, FINANCEADMIN]}>
      {type === "icon" ? (
        <Tooltip content="Reset Password" placement="bottom">
          <IconButton
            onClick={() => {
              setOpenModal("pop-up");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"
              />
            </svg>
          </IconButton>
        </Tooltip>
      ) : (
        <FlatButton
          size="lg"
          onClick={() => {
            setOpenModal("pop-up");
          }}
          // className="underline underline-offset-8 font-normal hover:text-indigo-500"
          appearance="secondary"
        >
          Reset Password
        </FlatButton>
      )}
      <Popup
        header={
          <p className="text-sm">Changing password for {data?.fullName}</p>
        }
        content={
          <>
            <div className="text-left mb-5">
              <TextBox
                type="password"
                className="mb-4"
                name="password"
                label="Enter new password"
                placeholder="New Password"
                formik={passwordForm}
              />
              <TextBox
                type="password"
                name="confirm_password"
                label="Confirm new password"
                placeholder="Re-type new Password"
                formik={passwordForm}
              />
            </div>
          </>
        }
        confirmText={`Reset password`}
        modalState={[openModal, setOpenModal]}
        alignActions="end"
        onClose={() => {
          resetForm();
        }}
        onCancel={() => {
          resetForm();
        }}
        onConfirm={() => {
          passwordForm.submitForm();
        }}
      />
      <Modal show={modalState} size="2xl" popup onClose={() => closeModal()}>
        <Modal.Header />
        <Modal.Body>
          <div className="flex flex-row flex-nowrap items-center">
            {qrCode && (
              <>
                <img className="h-13 w-13" src={qrCode.qr} alt="" />
                <h3 className="mb-5 ml-4 text-md font-normal text-gray-500 dark:text-gray-500">
                  Coworker's password has been updated successfully.
                  <br />
                  <br /> Please Scan the QR Code with Google Authenticator and
                  Save this Secret key to recover account incase if lost.
                  <br />
                  <p
                    className="cursor-pointer text-blue-500 text-underline"
                    onClick={() => {
                      window.open(qrCode.qr);
                    }}
                  >
                    Click here
                  </p>{" "}
                  to open QR Code in new tab <br />
                  <br />
                  <b className="font-bold text-md ">
                    SECRET KEY:
                    <br />{qrCode.secret_key}
                  </b>
                </h3>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </ACL>
  );
}
